import {Link} from "react-router-dom";
import React, {useContext} from "react";
import AuthContext from "../utilis/contexts/AuthContext";

type Props = {
    item: any,
    index: number
}
const BillCard = (props: Props) => {
    const authContext = useContext(AuthContext)
    const {item, index} = props;
    return <div className="bill-wrapper">
        <div className="bills-card  mb-5 bg-gray-100    rounded-lg">
            <div
                className="grid grid-cols-1 head bg-gray-200 border-gray-300 border  p-4 rounded-lg  md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 w-full gap-4 p-4">
                <div className="w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">نام:  </strong>
                    <span className="  text-extra-small mr-1">{item.name}</span>
                </div>
                <div className="w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">شماره پرونده:  </strong>
                    <span className="  text-extra-small mr-1">{authContext.currentFileNumber}</span>
                </div>
                <div className="  w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاریخ نصب:  </strong>
                    <span className="  text-extra-small mr-1">{item.installation_date
                    }</span>
                </div>
                <div className="  w-full mb-3 flex justify-start items-center">

                    <span
                        className=" text-extra-small mr-1">اگر قبض تاريخ نصب فاضلاب داشته باشد سيستم فاضلاب بها محاسبه می کند</span>
                </div>
                <div className="  w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاریخ آخرین پرداختی:  </strong>
                    <span className="  text-extra-small mr-1">{item.last_payment_date
                    }</span>
                </div>

                <div className="  w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small"> مبلغ آخرین پرداختی:  </strong>
                    <span className="  text-extra-small mr-1">{item.last_payment_amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }ریال</span>
                </div>
                <div className="  w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">آدرس:  </strong>
                    <span className=" text-extra-small mr-1">{item.city + " - " + item.address}</span>
                </div>

            </div>
            <div
                className=" grid p-4 grid-cols-1 md:grid-cols-8 lg:grid-cols-7 xl:grid-cols-7  w-full mb-3 mb-2 gap-1  p-3 ">
                <div className="w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">ردیف:  </strong>
                    <span className="  text-extra-small mr-1">{index}</span>
                </div>
                <div className="w-full mb-3 flex justify-start items-center">
                    <strong className="text-extra-small ">شماره قبض:  </strong>
                    <span className="  text-extra-small mr-1">{item.bill_serial}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاریخ سند:  </strong>
                    <span className="  text-extra-small mr-1">{item.document_date}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">شماره قبلی:  </strong>
                    <span className="  text-extra-small mr-1">{item.previous_number}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاریخ قبلی:  </strong>
                    <span className="  text-extra-small mr-1">{item.previous_date}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">آب بها: </strong>
                    <span className="  text-extra-small mr-1">{item.water_price}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">فاضلاب بها:  </strong>
                    <span className="  text-extra-small mr-1">{item.waster_water_subscription}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">کد کاربر:  </strong>
                    <span className="  text-extra-small mr-1">{item.user_id}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">قطر انشعاب:  </strong>
                    <span className="  text-extra-small mr-1">{item.branch_diameter}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">مابه التفاوت تعرفه:</strong>
                    <span className="  text-extra-small mr-1">{item.tariff_difference}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">شماره فعلی:  </strong>
                    <span className="  text-extra-small mr-1">{item.current_number}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاریخ فعلی:  </strong>
                    <span className="  text-extra-small mr-1">{item.current_date}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">آبونمان:  </strong>
                    <span className="  text-extra-small mr-1">{item.subscribtion}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small"> مالیات:  </strong>
                    <span className="  text-extra-small mr-1"><span
                        dir="ltr">{item.tax.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span><small>  ریال  </small></span>
                </div>
                <div className=" cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تعداد واحد:  </strong>
                    <span className="  text-extra-small mr-1">{item.units_number}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">کد تخفیفی:  </strong>
                    <span className="  text-extra-small mr-1">{item.discount}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">نوع قبض:  </strong>
                    <span className="  text-extra-small mr-1">{item.bill_type}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">مصرف:  </strong>
                    <span className="  text-extra-small mr-1">{item.total_consumption}</span>
                </div>

                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">وضعیت قبض:  </strong>
                    <span className="  text-extra-small mr-1">{item.bill_status}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">جریمه:  </strong>
                    <span className="  text-extra-small mr-1">{item.penalty}</span>
                </div>

                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small"> شهرداری:  </strong>
                    <span className="  text-extra-small mr-1"><span
                        dir="ltr">{item.city_hall_amount}</span><small>    </small></span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">نوع فروش:  </strong>
                    <span className="  text-extra-small mr-1">{item.selling_type}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">وضعیت کنتور:  </strong>
                    <span className="  text-extra-small mr-1">{item.meter_status}</span>
                </div>

                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small"> الگو:  </strong>
                    <span className="  text-extra-small mr-1"><span
                        dir="ltr">{item.standard}</span><small>    </small></span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">میانگین:  </strong>
                    <span className="  text-extra-small mr-1">{item.average_consumption}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small"> بدهی قبلی:  </strong>
                    <span className="  text-extra-small mr-1"><span
                        dir="ltr">{item.previous_debt.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span><small>  ریال  </small></span>
                </div>

                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تبصره۳:  </strong>
                    <span className="  text-extra-small mr-1">{item.note3}</span>
                </div>

                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">ماده واحد۷۶:  </strong>
                    <span className="  text-extra-small mr-1">{item.village_abfa_portion}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">کد مامور:  </strong>
                    <span className="  text-extra-small mr-1">{item.agent_code}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small"> ظرفیت قراردادی:  </strong>
                    <span className="  text-extra-small mr-1"><span
                        dir="ltr">{item.contract_capacity}</span><small>    </small></span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاریخ نصب فاضلاب:  </strong>
                    <span className="  text-extra-small mr-1">{item.waste_water_installation_date}</span>
                </div>

                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">مصرف تخفیفی:  </strong>
                    <span className="  text-extra-small mr-1">{item.discount_consumption}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">ماده۷:  </strong>
                    <span className="  text-extra-small mr-1">{item.note7}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تبصره۲:  </strong>
                    <span className="  text-extra-small mr-1">{item.note2}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">جمع قبض: </strong>
                    <span className="  text-extra-small text-red-400 mr-1">{((item.sum_bill)-(item.previous_debt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<small>ریال</small></span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small"> مازاد ظرفيت قراردادی:  </strong>
                    <span className="  text-extra-small  mr-1">{item.extra_contract_capacity}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">

                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">مصرف مازاد ظرفيت قراردادی:  </strong>
                    <span className="  text-extra-small  mr-1">{item.extra_contract_capacity_consumption}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تابستانه:  </strong>
                    <span className="  text-extra-small  mr-1">{item.summer_price.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<small>ریال</small></span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">نوع کاربری:  </strong>
                    <span className="  text-extra-small  mr-1">{item.account_type}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">

                </div>

                <div className="w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">جمع کل:  </strong>
                    <span className="  text-extra-small text-red-400 mr-1">{item.sum_bill.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<small>ریال</small></span>
                </div>
              {/*  <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاریخ صدور قبض:  </strong>
                    <span className="  text-extra-small mr-1">{item.bill_exportation_date}</span>
                </div>*/}
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">علت ابطال قبض: </strong>
                    <span className="  text-extra-small mr-1">{item.cancel_bill_reason}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">ارسال پیامک:  </strong>
                    <span className="  text-extra-small mr-1">{item.sms_send}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">تاییدیه پیامک:  </strong>
                    <span className="  text-extra-small mr-1">{item.sms_confirmation}</span>
                </div>
                <div className="cell w-full mb-3 flex justify-start items-center">
                    <strong className=" text-extra-small">نحوه قرائت:  </strong>
                    <span className="  text-extra-small mr-1">{item.reading_type}</span>
                </div>








            </div>
            {/*   <div className="mt-2 p-4 flex border-t justify-between items-center justify-items-between">
                <div className=" ">
                    <strong className=" text-extra-small">آدرس : </strong>
                    <span className=" text-extra-small mr-1">{item.city + " - " + item.address}</span>
                </div>
            </div>*/}
        </div>
    </div>
}
export default BillCard;